import React from "react";
import { FormattedMessage } from "./FormattedMessage";

interface NovaMessageProps {
  content: string;
}

const NovaMessage: React.FC<NovaMessageProps> = ({ content }) => {
  return (
    <div className="flex max-w-[400px] gap-3 w-full justify-start items-start transition-width duration-500 flex-col">
      <div className="flex flex-col justify-start max-w-[300px] w-full">
        <div className="pt-6 pb-2 flex justify-start items-center w-full">
          <div className="flex justify-start items-center gap-2">
            <div
              className="select-none bg-clip-text text-center text-lg
          select-none
          bg-clip-text text-transparent uppercase leading-none tracking-[0px] px-1 font-[0] font-[700]
         bg-[radial-gradient(61.17%_178.53%_at_38.83%_-13.54%,#003330_0%,#003330_15%,#003330_35%,#003330_50%,#00FFD1_70%,#003330_85%,#003330_100%)]"
            >
              Nova
            </div>
          </div>
        </div>
        <article className="max-w-[300px] w-full flex flex-col justify-center p-3 border border-gray-900 bg-customGray/90 rounded-2xl relative">
          <div className="absolute inset-0 bg-black/[0.60] rounded-2xl z-0"></div>
          <div className="prose break-words dark:prose-invert pt-1 w-full prose-gray text-sm prose-p:leading-relaxed prose-pre:p-0 overflow-hidden z-[1] text-white">
            <FormattedMessage content={content} />
          </div>
        </article>
      </div>
    </div>
  );
};

export default NovaMessage;
